import { JwAuthError } from "../packages/base/auth/error.js";
import { cookieManager } from "../packages/base/auth/cookies.js";
import { PromiseUtil } from "../nodemodules/@jwplayer/fe-common/module/util/promise/index.js";
import { getAuthFromAdminPayloadFromUrl } from "../packages/base/auth/from-admin.js";
import { AuthManager } from "../packages/base/auth/manager.js";
import { config } from "../config/index.js";
import { extractAuthToken } from "./util.js";

//#region src/auth/index.ts
var AuthGatewayManager = class extends AuthManager {
	constructor() {
		super({
			authCookieName: config.select((c) => c.auth.cookies.token),
			authTokenTtl: config.select((c) => c.auth.tokenTtl)
		});
	}
	async authenticate(opts) {
		const { authToken,...fromAdminPayload } = getAuthFromAdminPayloadFromUrl(config.get().auth.fromAdminQueryParam) ?? {};
		if (authToken) {
			this.clear();
			cookieManager.setCookie(config.select((c) => c.auth.cookies.authFromAdmin)(), JSON.stringify(fromAdminPayload));
		}
		return super.authenticate({
			...opts,
			authToken
		});
	}
	clear() {
		cookieManager.deleteCookie(config.select((c) => c.auth.cookies.authFromAdmin)());
		super.clear();
	}
	authenticateApi = PromiseUtil.coalesce(async (opts) => {
		const { jwApi } = await import("../api/index.js");
		const obj = (await jwApi("dashboard-scope", "read", {}, opts)).data;
		return {
			obj,
			token: extractAuthToken(obj)
		};
	});
	/**
	* Authenticate a user with the API Gateway.
	*
	* In case MFA is set up for the user, the error `MFA_REQUIRED` is thrown when
	* the user needs to enter their MFA code.
	*/
	loginApi = PromiseUtil.coalesce(async ({ email, password, mfaCode, rememberMfa }, opts) => {
		const { jwApi } = await import("../api/index.js");
		email = email.trim();
		password = password.trim();
		mfaCode = mfaCode?.trim();
		const mfaCookieIdentifier = config.get().auth.cookies.mfa.identifier;
		const mfaSignature = cookieManager.getCookie(mfaCookieIdentifier)?.trim();
		const res = await jwApi("dashboard-scope", "create", { input: {
			email,
			password,
			code: mfaCode || void 0,
			remember_mfa: mfaCode ? !!rememberMfa : void 0,
			mfa_signature: mfaSignature || void 0
		} }, opts);
		if (res.status === 204) {
			cookieManager.deleteCookie(mfaCookieIdentifier);
			throw new JwAuthError("MFA_REQUIRED");
		}
		if (!res.data) throw new JwAuthError("RESPONSE_EMPTY");
		if (res.data.authentication.mfa && typeof res.data.authentication.mfa === "string") cookieManager.setCookie(mfaCookieIdentifier, res.data.authentication.mfa, { "Max-Age": config.get().auth.cookies.mfa.ttl });
		cookieManager.deleteCookie(config.select((c) => c.auth.cookies.authFromAdmin)());
		return {
			obj: res.data,
			token: extractAuthToken(res.data)
		};
	});
};
const auth = new AuthGatewayManager();

//#endregion
export { auth };
//# sourceMappingURL=index.js.map